<template>
<div id="Header">
  <Announce />
  <div class="row no_side_margin header">
    <div class="col-lg-3 logo">
      <a href="https://uproc.io" target="_blank">
        <svg width="112" height="56" viewBox="0 0 112 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M57.508 24.164V36H54.252V34.592C53.7973 35.1053 53.2547 35.5013 52.624 35.78C51.9933 36.044 51.3113 36.176 50.578 36.176C49.0233 36.176 47.7913 35.7287 46.882 34.834C45.9727 33.9393 45.518 32.612 45.518 30.852V24.164H48.95V30.346C48.95 32.2527 49.7493 33.206 51.348 33.206C52.1693 33.206 52.8293 32.942 53.328 32.414C53.8267 31.8713 54.076 31.072 54.076 30.016V24.164H57.508ZM67.5955 20.6C68.9595 20.6 70.1402 20.8273 71.1375 21.282C72.1495 21.7367 72.9269 22.382 73.4695 23.218C74.0122 24.054 74.2835 25.044 74.2835 26.188C74.2835 27.3173 74.0122 28.3073 73.4695 29.158C72.9269 29.994 72.1495 30.6393 71.1375 31.094C70.1402 31.534 68.9595 31.754 67.5955 31.754H64.4935V36H60.9295V20.6H67.5955ZM67.3975 28.85C68.4682 28.85 69.2822 28.6227 69.8395 28.168C70.3968 27.6987 70.6755 27.0387 70.6755 26.188C70.6755 25.3227 70.3968 24.6627 69.8395 24.208C69.2822 23.7387 68.4682 23.504 67.3975 23.504H64.4935V28.85H67.3975ZM79.864 25.726C80.2746 25.154 80.8246 24.7213 81.514 24.428C82.218 24.1347 83.0246 23.988 83.934 23.988V27.156C83.5526 27.1267 83.296 27.112 83.164 27.112C82.1813 27.112 81.4113 27.3907 80.854 27.948C80.2966 28.4907 80.018 29.312 80.018 30.412V36H76.586V24.164H79.864V25.726ZM91.4992 36.176C90.2525 36.176 89.1305 35.9193 88.1332 35.406C87.1505 34.878 86.3805 34.152 85.8232 33.228C85.2659 32.304 84.9872 31.2553 84.9872 30.082C84.9872 28.9087 85.2659 27.86 85.8232 26.936C86.3805 26.012 87.1505 25.2933 88.1332 24.78C89.1305 24.252 90.2525 23.988 91.4992 23.988C92.7459 23.988 93.8605 24.252 94.8432 24.78C95.8259 25.2933 96.5959 26.012 97.1532 26.936C97.7105 27.86 97.9892 28.9087 97.9892 30.082C97.9892 31.2553 97.7105 32.304 97.1532 33.228C96.5959 34.152 95.8259 34.878 94.8432 35.406C93.8605 35.9193 92.7459 36.176 91.4992 36.176ZM91.4992 33.36C92.3792 33.36 93.0979 33.0667 93.6552 32.48C94.2272 31.8787 94.5132 31.0793 94.5132 30.082C94.5132 29.0847 94.2272 28.2927 93.6552 27.706C93.0979 27.1047 92.3792 26.804 91.4992 26.804C90.6192 26.804 89.8932 27.1047 89.3212 27.706C88.7492 28.2927 88.4632 29.0847 88.4632 30.082C88.4632 31.0793 88.7492 31.8787 89.3212 32.48C89.8932 33.0667 90.6192 33.36 91.4992 33.36ZM106.003 36.176C104.742 36.176 103.605 35.9193 102.593 35.406C101.596 34.878 100.811 34.152 100.239 33.228C99.6819 32.304 99.4032 31.2553 99.4032 30.082C99.4032 28.9087 99.6819 27.86 100.239 26.936C100.811 26.012 101.596 25.2933 102.593 24.78C103.605 24.252 104.742 23.988 106.003 23.988C107.25 23.988 108.335 24.252 109.259 24.78C110.198 25.2933 110.88 26.034 111.305 27.002L108.643 28.432C108.027 27.3467 107.14 26.804 105.981 26.804C105.087 26.804 104.346 27.0973 103.759 27.684C103.173 28.2707 102.879 29.07 102.879 30.082C102.879 31.094 103.173 31.8933 103.759 32.48C104.346 33.0667 105.087 33.36 105.981 33.36C107.155 33.36 108.042 32.8173 108.643 31.732L111.305 33.184C110.88 34.1227 110.198 34.856 109.259 35.384C108.335 35.912 107.25 36.176 106.003 36.176Z"
            fill="white" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M21.128 19.2157C21.128 29.1037 15.464 34.5757 5.91199 34.5757C4.21059 34.5757 2.63256 34.4021 1.1879 34.0609C3.57657 39.8921 9.30858 43.9997 16 43.9997C24.8365 43.9997 32 36.8363 32 27.9997C32 20.9568 27.4494 14.9766 21.128 12.8392V19.2157ZM0.191528 25.5164C1.47677 27.1963 3.44367 27.9517 5.95999 27.9517C10.712 27.9517 13.448 25.3117 13.448 18.9277V12.2021C6.63255 13.2946 1.25504 18.6914 0.191528 25.5164Z"
            fill="white" />
        </svg>
      </a>
    </div>
    <div class="col-lg-6 text-center d-flex align-items-center justify-content-center">
      {{$t('top-title')}}
    </div>
    
  </div>

  <!--div class="loader-wrap" v-if="this.isLoading">
    <div class="loader">Loading...</div>
  </div-->
  <div
    class="loader-wrap" v-if="this.isLoading"
    :class="{ 'loader--visible': isLoading }"
    >
    <div class="loader">Loading...</div>
  </div>

</div>
</template>

<script>
import Announce from '@/components/Changes/Announce.vue';

export default {
  name: 'Header',
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    this.$root.$on('isLoading', (result) => {
      this.isLoading = result;
    })
  },
  components: {
    Announce
  },
  methods: {

    logOut: function() {

      localStorage.token = '';
      this.$router.push("/login");
      location.reload();

    },

    loginChecker() {
      return localStorage.token && localStorage.token != this.$defaultKey ? true : false;

    }

  }
}
</script>
